/**
 * FE-GC-1 — overview group settings list without /api mirror probe (DEF-FE-C2g-9-002).
 */

import { buildGetGroupCardsSettingsPath } from "./group-console-api.js";

/** @param {unknown} err */
function isGroupSettingsRouteMissing(err) {
  const msg = String((err && err.message) || err || "");
  return msg.includes("404") || msg.includes("405") || msg.includes("501");
}

/**
 * @param {(path: string, opts?: object) => Promise<unknown>} apiFn
 * @param {{ timeoutMs?: number; retries?: number }} [opts]
 */
export async function fetchOverviewGroupSettingsList(apiFn, opts = {}) {
  try {
    return await apiFn(buildGetGroupCardsSettingsPath(), {
      timeoutMs: opts.timeoutMs != null ? opts.timeoutMs : 12000,
      retries: opts.retries != null ? opts.retries : 1,
    });
  } catch (e) {
    if (isGroupSettingsRouteMissing(e)) return { items: [], routeMissing: true };
    throw e;
  }
}
